import { render, staticRenderFns } from "./CUDataTable.vue?vue&type=template&id=1806ea81"
import script from "./CUDataTable.vue?vue&type=script&lang=ts"
export * from "./CUDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports